import adminApi from "./admin";

export async function getActionBySlug(slug: string) {
	try {
		const res = await adminApi.get(
			`/actions?where[slug][equals]=${slug}&limit=1`
		);

		return res.data.docs[0];
	} catch (error) {
		console.error(error);
		throw new Error("Erro inesperado");
	}
}
